import { Response } from "@/shared/models/Response";
import axios from "axios";
import { DataResponse } from "../models/EventDataResponse";
import { EventQuery } from "../models/EventQuery";
import { NoteResponse, NotesResponse } from "../models/NotesResponse";

export class EventService {
  private baseUrl: string;
  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/events-timeline`;
  }

  async getEventByFilter(query: EventQuery): Promise<Response<DataResponse>> {
    const response = await axios.get(`${this.baseUrl}/filter`, {
      params: query
    });
    return response.data;
  }

  async getNotesByEventTimeLineId(
    eventTimeLineId: string,
    eventUserId: string
  ): Promise<Response<NotesResponse>> {
    const response = await axios.get(
      `${this.baseUrl}/notes/${eventTimeLineId}?eventUserId=${eventUserId}`
    );
    return response.data;
  }

  async getNotesByServiceId(
    serviceId: string
  ): Promise<Response<NotesResponse>> {
    const response = await axios.get(
      `${this.baseUrl}/notes-by-service/${serviceId}`
    );
    return response.data;
  }

  async addNote(note: {
    note: string;
    userId: string;
    eventsTimeLineId?: string;
  }): Promise<Response<NoteResponse>> {
    const response = await axios.post(`${this.baseUrl}/notes`, note);
    return response.data;
  }
}
